export default "__VITE_ASSET__C19CxU30__"